import i18n from "dev/lang";

function $t(key) {
	return i18n.t(key);
}

export default [
	$t("pages.measurmentArea.Cabinet"),
	$t("pages.measurmentArea.Electricalcabinet"),
	$t("pages.measurmentArea.HallCloset"),
	$t("pages.measurmentArea.Cupboardunderthestairs"),
	$t("pages.measurmentArea.Boidm"),
	$t("pages.measurmentArea.door"),
	$t("pages.measurmentArea.lowering"),
	$t("pages.measurmentArea.aroom"),
	$t("pages.measurmentArea.GuestBathroom"),
	$t("pages.measurmentArea.Masterbathroom"),
	$t("pages.measurmentArea.GeneralBathroom"),
	$t("pages.measurmentArea.Walkincloset"),
	$t("pages.measurmentArea.Masterbedroom"),
	$t("pages.measurmentArea.ChildrensRoom"),
	$t("pages.measurmentArea.Laundryroom"),
	$t("pages.measurmentArea.APSRoom"),
	$t("pages.measurmentArea.kitchen"),
	$t("pages.measurmentArea.Kitchenette"),
	$t("pages.measurmentArea.corridor"),
	$t("pages.measurmentArea.Shower"),
	$t("pages.measurmentArea.Terrace"),
	$t("pages.measurmentArea.basement"),
	$t("pages.measurmentArea.Niche"),
	$t("pages.measurmentArea.Onlyniche"),
	$t("pages.measurmentArea.Livingroom"),
	$t("pages.measurmentArea.diningroom"),
	$t("pages.measurmentArea.wall"),
	$t("pages.measurmentArea.Wallcabinet"),
	$t("pages.measurmentArea.wholeHouse"),
	$t("pages.measurmentArea.Synagogue"),
	$t("pages.measurmentArea.serviceroom"),
	$t("pages.measurmentArea.stairs"),
	$t("pages.measurmentArea.CustomadeFurniture"),
	$t("pages.measurmentArea.Pantry"),
	$t("pages.measurmentArea.bathroom"),
	$t("pages.measurmentArea.warehouse"),
	"מטבח חוץ",
	"ארון שירות"
];
